import axios from 'axios'
import requesturl from '../requesturl'
import auth from "../auth";
import cookiemanager from "../managers/cookiemanager";

export default {

    async getSystemSettings(systemSettings) {
        await axios.get(requesturl() + "/api/latest/SystemSetting", {headers: {Authorization: window.$cookies.get("token")}})
            .then((res) => {
                systemSettings(res.data);
                cookiemanager.updateCookies(res.headers);
            })
            .catch(error => {
                if (error.response && error.response.status === 401) {
                    auth.logout();
                    window.$router.push('login');
                }
            });
    },

    async deleteSystemSetting(systemSetting, response) {
        await axios.delete(requesturl() + "/api/latest/SystemSetting/" + systemSetting.systemSettingId,
            {headers: {Authorization: window.$cookies.get("token")}})
            .then((res) => {
                cookiemanager.updateCookies(res.headers);
                let responseObj = {
                    error: false,
                    status: res.status
                };
                response(responseObj);
            })
            .catch(error => {
                let responseObj = {
                    error: true,
                    status: error.response != null ? error.response.status : 503
                };

                if (error.response && error.response.status === 401) {
                    auth.logout();
                    window.$router.push('login');
                }
                response(responseObj);
            });
    },

    async postSystemSetting(systemSetting, response) {

        let headers = {
            'Authorization': window.$cookies.get("token"),
            'Content-Type': 'application/json'
        };

        await axios({
            method: 'post',
            url: requesturl() + '/api/latest/SystemSetting',
            headers: headers,
            data: JSON.stringify(systemSetting)
        }).then((res) => {
            cookiemanager.updateCookies(res.headers);
            let responseObj = {
                error: false,
                status: res.status
            };

            response(responseObj);
        }).catch(error => {
            let responseObj = {
                error: true,
                status: error.response != null ? error.response.status : 503
            };

            if (error.response && error.response.status === 401) {
                auth.logout();
                window.$router.push('login');
            }

            response(responseObj);
        });
    },

    async putSystemSetting(systemSetting, response) {

        let headers = {
            'Authorization': window.$cookies.get("token"),
            'Content-Type': 'application/json'
        };

        await axios({
            method: 'put',
            url: requesturl() + '/api/latest/SystemSetting/' + systemSetting.systemSettingId,
            headers: headers,
            data: JSON.stringify(systemSetting)
        }).then((res) => {
            cookiemanager.updateCookies(res.headers);
            let responseObj = {
                error: false,
                status: res.status
            };

            response(responseObj);
        }).catch(error => {
            let responseObj = {
                error: true,
                status: error.response != null ? error.response.status : 503
            };

            if (error.response && error.response.status === 401) {
                auth.logout();
                window.$router.push('login');
            }

            response(responseObj);
        });
    }
}



// WEBPACK FOOTER //
// ./src/interfaces/systemsettinginterface.js